import {
    buyerActiveItemsColumns,
    buyerItemsLostColumns,
    buyerPurchasesColumns,
    sellerActiveColumns,
    sellerSoldColumns,
    sellerUnsoldColumns,
    payments2Columns
} from './../constants/column-definitions';
import { PAGE_LIST_TYPES } from '../constants/list-types';
import { PAGE_NAMES } from '../constants/page';
import HeartIcon from '@tradera/blueprint/theme/icons/heart.svg';
import BookmarkIcon from '@tradera/blueprint/theme/icons/bookmark.svg';
import StarIcon from '@tradera/blueprint/theme/icons/star.svg';
import MailIcon from '@tradera/blueprint/theme/icons/mail.svg';
import CrossIcon from '@tradera/blueprint/theme/icons/cross.svg';
import TagIcon from '@tradera/blueprint/theme/icons/tag.svg';
import CheckIcon from '@tradera/blueprint/theme/icons/check.svg';
import ListIcon from '@tradera/blueprint/theme/icons/list.svg';
import ComposeIcon from '@tradera/blueprint/theme/icons/compose.svg';
import SettingsIcon from '@tradera/blueprint/theme/icons/settings.svg';
import HamburgerIcon from '@tradera/blueprint/theme/icons/hamburger.svg';
import BiddingIcon from '@tradera/blueprint/theme/icons/bidding.svg';
import WonIcon from '@tradera/blueprint/theme/icons/won.svg';
import FileIcon from '@tradera/blueprint/theme/icons/file.svg';

export const getLocalizedUrls = toLocalizedUrl => ({
    overview: toLocalizedUrl('/my/overview'),
    buyerOverview: toLocalizedUrl('/my/overview-buyer'),
    sellerOverview: toLocalizedUrl('/my/overview-seller'),
    accountOverview: toLocalizedUrl('/my/overview-my-account'),
    wishlist: toLocalizedUrl('/my/wish-list'),
    activeItems: toLocalizedUrl('/my/active-items'),
    itemsLost: toLocalizedUrl('/my/items-lost'),
    active: toLocalizedUrl('/my/active'),
    sold: toLocalizedUrl('/my/sold'),
    unsold: toLocalizedUrl('/my/unsold'),
    purchases: toLocalizedUrl('/my/purchases'),
    savedSearches: toLocalizedUrl('/my/saved-searches'),
    favouriteSellers: toLocalizedUrl('/my/favourite-sellers'),
    pickList: toLocalizedUrl('/my/picklist'),
    buyerFeedback: toLocalizedUrl('/my/leave-feedback/buyer'),
    sellerFeedback: toLocalizedUrl('/my/leave-feedback/seller'),
    myFeedback: toLocalizedUrl('/my/feedback'),
    profile: toLocalizedUrl('/my/profile'),
    invoices: toLocalizedUrl('/my/Invoices'),
    payments: toLocalizedUrl('/my/Payments'),
    paymentsKlarna: toLocalizedUrl('/my/Payments/Payouts?page=1'),
    payments2: toLocalizedUrl('/my/Payments2'),
    klarna: toLocalizedUrl('/my/Klarna'),
    messaging: toLocalizedUrl('/messaging')
});

/**
 * This is default information used to differentiate UI elements based on different pages.
 * @returns {object}
 */
export const routeInformationFactory = (t, toLocalizedUrl) => {
    const urls = getLocalizedUrls(toLocalizedUrl);
    return {
        [urls.overview]: {
            url: toLocalizedUrl('/my/overview'),
            class: 'myt-menu-list-item-subtitle',
            label: t('myt_overview_label'),
            isExternal: true
        },
        [urls.wishlist]: {
            url: toLocalizedUrl('/my/wish-list'),
            title: t('myt_wishlist_title'),
            isExternal: true,
            icon: HeartIcon
        },
        [urls.savedSearches]: {
            url: toLocalizedUrl('/my/saved-searches'),
            title: t('myt_savedSearches_title'),
            isExternal: true,
            icon: BookmarkIcon
        },
        [urls.favouriteSellers]: {
            url: toLocalizedUrl('/my/favourite-sellers'),
            title: t('myt_favouriteSellers_title'),
            isExternal: true,
            icon: StarIcon
        },
        [urls.activeItems]: {
            isBuyerPage: true,
            searchUrl: toLocalizedUrl('/my/api/buyer/active'),
            pageName: PAGE_NAMES.BuyerActiveItems,
            listType: PAGE_LIST_TYPES.BUYER_ACTIVE_ITEMS,
            url: toLocalizedUrl('/my/active-items'),
            title: t('myt_activeItems_title'),
            columns: buyerActiveItemsColumns,
            overview: urls.buyerOverview,
            hasLabels: false,
            shouldShowCompact: false,
            gaLabel: 'Pågående budgivningar',
            subHeadings: true,
            bulkEditEnabled: true,
            icon: BiddingIcon,
            noResultsText: t('myt_activeItems_noResultsText')
        },
        [urls.itemsLost]: {
            isBuyerPage: true,
            searchUrl: toLocalizedUrl('/my/api/buyer/items-lost'),
            pageName: PAGE_NAMES.BuyerItemsLost,
            listType: PAGE_LIST_TYPES.BUYER_ITEMS_LOST,
            overview: urls.buyerOverview,
            url: toLocalizedUrl('/my/items-lost'),
            title: t('myt_lostItems_title'),
            columns: buyerItemsLostColumns,
            hasLabels: false,
            shouldShowCompact: false,
            bulkEditEnabled: true,
            icon: CrossIcon,
            noResultsText: t('myt_lostItems_noResultsText')
        },
        [urls.active]: {
            searchUrl: toLocalizedUrl('/my/api/seller/active'),
            pageName: PAGE_NAMES.SellerActive,
            listType: PAGE_LIST_TYPES.SELLER_ACTIVE,
            url: toLocalizedUrl('/my/active'),
            overview: urls.sellerOverview,
            title: t('myt_activeListings_title'),
            columns: sellerActiveColumns,
            hasLabels: false,
            shouldShowCompact: true,
            subHeadings: true,
            stats: {
                FastPris: {
                    label: 'Fast pris',
                    value: '0'
                },
                Auktioner: {
                    label: 'Auktioner',
                    value: '0'
                },
                Bud: {
                    label: 'Bud',
                    value: '0'
                },
                SummaUtropspris: {
                    label: 'Summa utropspris',
                    value: '0'
                },
                SummaBud: {
                    label: 'Summa bud',
                    value: '0'
                }
            },
            bulkEditEnabled: true,
            icon: TagIcon,
            noResultsText: t('myt_activeListings_noResultsText')
        },
        [urls.sold]: {
            searchUrl: toLocalizedUrl('/my/api/seller/sold'),
            pageName: PAGE_NAMES.SellerSold,
            listType: PAGE_LIST_TYPES.SELLER_SOLD,
            url: toLocalizedUrl('/my/sold'),
            title: t('myt_soldItems_title'),
            columns: sellerSoldColumns,
            overview: urls.sellerOverview,
            hasLabels: true,
            shouldShowCompact: true,
            subHeadings: true,
            stats: {
                Butiksobjekt: {
                    label: 'Butiksobjekt',
                    value: '0'
                },
                FastPris: {
                    label: 'Fast pris',
                    value: '0'
                },
                Auktioner: {
                    label: 'Auktioner',
                    value: '0'
                },
                Bud: {
                    label: 'Bud',
                    value: '0t'
                },
                SummaUtropspris: {
                    label: 'Summa utropspris',
                    value: '0'
                },
                SummaBud: {
                    label: 'Summa bud',
                    value: '0'
                }
            },
            bulkEditEnabled: false,
            icon: CheckIcon,
            noResultsText: t('myt_soldItems_noResultsText')
        },
        [urls.unsold]: {
            searchUrl: toLocalizedUrl('/my/api/seller/unsold'),
            pageName: PAGE_NAMES.SellerUnsold,
            listType: PAGE_LIST_TYPES.SELLER_NOT_SOLD,
            overview: urls.sellerOverview,
            url: toLocalizedUrl('/my/unsold'),
            title: t('myt_unsoldItems_title'),
            columns: sellerUnsoldColumns,
            shouldShowCompact: true,
            subHeadings: true,
            stats: {},
            bulkEditEnabled: true,
            icon: CrossIcon,
            noResultsText: t('myt_unsoldItems_noResultsText')
        },
        [urls.purchases]: {
            isBuyerPage: true,
            searchUrl: toLocalizedUrl('/my/api/buyer/purchases'),
            pageName: PAGE_NAMES.BuyerPurchases,
            listType: PAGE_LIST_TYPES.BUYER_PURCHASES,
            url: toLocalizedUrl('/my/purchases'),
            overview: urls.buyerOverview,
            title: t('myt_boughtItems_title'),
            columns: buyerPurchasesColumns,
            shouldShowCompact: false,
            stats: {},
            bulkEditEnabled: true,
            icon: WonIcon,
            noResultsText: t('myt_boughtItems_noResultsText')
        },
        [urls.pickList]: {
            url: toLocalizedUrl('/my/picklist'),
            title: t('myt_picklist_title'),
            isExternal: true,
            icon: HamburgerIcon
        },
        [urls.buyerFeedback]: {
            url: toLocalizedUrl('/my/leave-feedback/buyer?transactionId=0'),
            title: t('myt_buyerFeedback_title'),
            isExternal: true,
            icon: ComposeIcon
        },
        [urls.sellerFeedback]: {
            url: toLocalizedUrl('/my/leave-feedback/seller?transactionId=0'),
            title: t('myt_sellerFeedback_title'),
            isExternal: true,
            icon: ComposeIcon
        },
        [urls.myFeedback]: {
            url: toLocalizedUrl('/getUrlMyFeedback'),
            title: t('myt_myFeedback_title'),
            isExternal: true,
            icon: StarIcon
        },
        [urls.profile]: {
            url: toLocalizedUrl('/my/profile'),
            title: t('myt_settings_title'),
            isExternal: true,
            icon: SettingsIcon
        },
        [urls.invoices]: {
            url: toLocalizedUrl('/my/Invoices?page=1'),
            title: t('myt_invoices_title'),
            isExternal: true,
            icon: FileIcon
        },
        [urls.paymentsKlarna]: {
            url: toLocalizedUrl('/my/Payments/Payouts?page=1'),
            title: t('myt_klarna_title'),
            isExternal: true,
            showBasedOnInitData: initData => {
                return (
                    initData &&
                    initData.paymentSettings &&
                    initData.paymentSettings.showPayments1Menu === true &&
                    initData.paymentSettings.showPayments2Menu === true
                );
            },
            icon: ListIcon
        },
        [urls.payments]: {
            url: toLocalizedUrl('/my/Payments'),
            title: t('myt_payments_title'),
            isExternal: true,
            showBasedOnInitData: initData => {
                return (
                    initData &&
                    initData.paymentSettings &&
                    initData.paymentSettings.showPayments1Menu === true &&
                    initData.paymentSettings.showPayments2Menu === false
                );
            },
            icon: ListIcon
        },
        [urls.payments2]: {
            url: toLocalizedUrl('/my/Payments2'),
            title: t('myt_payments_title'),
            isExternal: true,
            showBasedOnInitData: initData => {
                return (
                    initData &&
                    initData.paymentSettings &&
                    initData.paymentSettings.showPayments2Menu === true
                );
            },
            icon: ListIcon,
            columns: payments2Columns
        },
        [urls.klarna]: {
            url: toLocalizedUrl('/my/Klarna'),
            title: t('myt_klarna_title'),
            isExternal: true,
            showBasedOnInitData: initData => {
                return (
                    initData &&
                    initData.paymentSettings &&
                    initData.paymentSettings.showKlarnaMenu === true
                );
            },
            icon: ListIcon
        },
        [urls.messaging]: {
            url: toLocalizedUrl('/messaging'),
            label: t('myt_messaging_label'),
            class: 'myt-menu-list-item-subtitle',
            hideMainNav: true,
            isExternal: true,
            icon: MailIcon
        }
    };
};
